/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const validateCardRequestRequestSchema = z
	.object({
		card_number: z.string().min(1),
	})
	.describe("Сериализатор для валидации номера карты лояльности.");
